/** Map Node `/api/ep/orders` rows to PWA card fields. */

export type EpOrderApiRow = {
  id: string;
  order_code?: string;
  seller_id: number;
  buyer_id?: number | null;
  amount_ep: string;
  price_cny: string;
  status: string;
  payment_methods?: string[] | string;
  create_time: string;
  claim_time?: string | null;
  pay_time?: string | null;
  release_time?: string | null;
};

export type EpOrderUi = {
  id: string;
  order_code?: string;
  seller_id: number;
  buyer_id?: number | null;
  amount: string;
  unit_price: string;
  status: string;
  create_time: string;
  payment_methods?: string[];
};

export function mapEpOrderRow(row: EpOrderApiRow): EpOrderUi {
  const methods = row.payment_methods;
  return {
    id: row.id,
    order_code: row.order_code,
    seller_id: row.seller_id,
    buyer_id: row.buyer_id ?? null,
    amount: row.amount_ep,
    unit_price: row.price_cny,
    status: row.status,
    create_time: row.create_time,
    payment_methods: Array.isArray(methods)
      ? methods
      : typeof methods === 'string'
        ? methods.split(',').filter(Boolean)
        : undefined,
  };
}

export function mapEpOrderList<T extends EpOrderApiRow>(
  data: { total: number; rows?: T[] | null },
): { total: number; rows: EpOrderUi[] } {
  return { total: data.total ?? 0, rows: (data.rows ?? []).map(mapEpOrderRow) };
}
